export default "__VITE_ASSET__Dt60EoCA__"